import {mixins} from "../app/mixin";

mixins.push({
    el: '.referenceCategory',
    data() {
        return {
            companyNamesForJS: companyNamesForJS,
            showNoResult: false,
            searchQuery: '',
            hidedCompanies: new Array(window.companyNamesForJS.length).fill(false),
        }
    },
    methods: {
        searchFilterChange() {
            const filter = this.searchQuery.toLowerCase();

            const _hidedCompanies = this.hidedCompanies;
            let _showNoResult = true;

            for (let i = 0; i < this.companyNamesForJS.length; i++) {
                if (this.companyNamesForJS[i].includes(filter)) {
                    _hidedCompanies[i] = false;

                    if (_showNoResult) {
                        _showNoResult = false;
                    }
                } else {
                    _hidedCompanies[i] = true;
                }
            }

            this.showNoResult = _showNoResult;
            this.hidedCompanies = _hidedCompanies;
        }
    }
});